import qs from 'qs';
import { network } from 'services/network';

export const getPoapPrimaryViews = (params) => {
    const { customerId } = params;
    const queryString = qs.stringify({ customerId }, { addQueryPrefix: true, skipNulls: true });
    const url = `api/bo/getPoapPrimaryViews${queryString}`;

    return network.get(url).then((response) => response.data);
};
